// oxlint-disable react/react-compiler -- React Compiler bails out of this file; remove when fixed
import { styled } from "goober";
import { nanoid } from "nanoid";
import { useRef } from "react";
import { createPortal } from "react-dom";

const BasePopover = styled("div")`
  position: fixed;
  border-radius: 12px;
`;

type Props = {
  isOpen: boolean;
  trigger: (props: { style: React.CSSProperties }) => React.ReactNode;
  children: React.ReactNode;
  popoverRef?: React.Ref<HTMLDivElement>;
  className?: string;
  target?: string;
  popoverAnchorName?: string;
  style?: React.CSSProperties;
  direction?: "down" | "up" | "left" | "right";
};

export function AnchoredPopover({
  isOpen,
  trigger,
  children,
  popoverRef,
  className,
  target,
  popoverAnchorName,
  style,
  direction,
}: Props) {
  const id = useRef(`--popover-${nanoid()}`);
  const wrapperRef = useRef<HTMLDivElement>(null);

  const getContainer = () =>
    wrapperRef.current?.closest("[data-popover-host], dialog") ?? document.body;

  return (
    <div ref={wrapperRef} style={{ display: "contents" }}>
      {trigger({ style: { anchorName: id.current } as React.CSSProperties })}
      {isOpen &&
        createPortal(
          <BasePopover
            ref={popoverRef}
            className={className}
            data-popover
            data-direction={direction}
            style={
              {
                ...style,
                positionAnchor: target ?? id.current,
                anchorName: popoverAnchorName,
                "--anchor-top": target ?? id.current,
                "--anchor-left": target ?? id.current,
              } as React.CSSProperties
            }
          >
            {children}
          </BasePopover>,
          getContainer()
        )}
    </div>
  );
}
